import React, { useState } from 'react';
import { Button, Grid, Menu } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import UsernameDisplay from './UsernameDisplay';
import VersionDisplay from './VersionDisplay';
import { msalInstance } from '../../msalConfig';

export default function AccountSection() {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const openAccountMenu = (event: any) => setAnchorEl(event.currentTarget);
    const closeAccountMenu = () => setAnchorEl(null);

    return (
        <div>
            <Button onClick={openAccountMenu} aria-haspopup="true" color="inherit" size="small">
                {
                    <Grid >
                        <UsernameDisplay />
                        <VersionDisplay />
                    </Grid>
                }
                <Grid>
                    <AccountCircle style={{ marginLeft: "10px", marginTop: "10px" }} fontSize="large" />
                </Grid>
            </Button>
            <Menu 
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                PaperProps={{
                    style: {
                        marginLeft: "17px", width: "250px", borderRadius: "0px", backgroundColor: "rgb(70, 64, 94)"
                    }
                }}
                onClose={closeAccountMenu}
            >
                <Grid style={{ padding: "5px" }}>
                    <Button onClick={() => msalInstance.logoutRedirect()} style={{ marginTop: "5px", borderRadius: "0px", width: "100%" }} color="primary" variant="contained">Log Out</Button>
                </Grid>
            </Menu>
        </div>
    );
}